<template>
  <div class="action action--colors">
    <label class="action__label secondary-color-txt font-size-16 font-sanpro-semi-bold">Màu sắc</label>
    <div class="action__section__list display-flex-wrap">
      <div
        v-for="(item, index) of colors" class="item display-inline-block cursor-pointer"
        :class="{'active': item === colorActive}"
        :style="{background: item}"
        @click="changeColorElm(item)"
      ></div>
      <div
        class="item display-flex-center justify-content-center cursor-pointer item--plus position-rel"
        :style="{background: otherColor ? otherColor : '#fff'}"
      >
        <i class="icon-plus font-size-18"></i>
        <input type="color" value="" class="cursor-pointer" @change="changeOtherColor" />
      </div>
    </div>
  </div>
</template>

<script>
const colors = ['#40505E', '#879AA9', '#0F3DBA', '#F46055', '#FFCC66', '#5FCEA1', '#3B6BDD', '#FFFFFF'];

export default {
  name: 'SidebarActionColor',
  props: {
    colorActive: ''
  },
  data () {
    return {
      colors,
      otherColor: ''
    }
  },
  methods: {
    changeColorElm (val) {
      this.$emit('changeColor', val)
    },

    changeOtherColor (evt) {
      this.otherColor = evt.target.value
      this.changeColorElm(evt.target.value)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>